import React, { ChangeEvent, useEffect, useState } from "react";
import { useFormik } from "formik";
import TextInput from "../../../../common/TextInput";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import { PICKLIST_GROUP_NAME, WEB_ROLE } from "../../../../common/Constant";
import {
  fetcheaderinfo,
  fetchPickListByGroupName,
} from "../../../../services/UserRegistrationApi";
import {
  addStakeholderContact,
  GetDoctorDetails,
  GetStakeholderContactInfo,
  GetStakeholderLocationsList,
  getuserName,
  getUserRoleForPMC,
  updateStakeholderContact,
} from "../../../../services/StakeholderApi";
import {
  CONTACT_LOG_HEADERS,
  STAKEHOLDERS_CONTACT,
  STAKEHOLDERS_QME_CONTACT,
} from "../actions/Constant";
import DataTable from "../../../../common/DataTable";
import { validateStakeholderContactInfo } from "./stakeholderValidation";
import Snackbar from "../../../../common/Snackbar";
import { STAKEHOLDER_TYPE } from "../../../../common/Constant";
import {
  Form,
  Modal,
  Button,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
  Tabs,
  Tab,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import moment from "moment";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import AssociatedClinicForm from "./AssociatedClinicForm";
import FormattedPhoneInput from "../../../../common/FormattedPhoneInput";
import AccordionComponent from "../../../../common/Accordion";
import AddNewContactUser from "./AddNewContactUser";
import AddNewUserDrawer from "./AddNewUserDrawer";
import TagComponent from "../../../../common/TagComponent";
import { PARTIES_MASTER_ACTIONS } from "../../../../common/EventConstant";
import PartyNotificationPreference from "./PartyNotificationPreference";
import { addPartyNotificationConfiguration } from "../../../../services/NotificationConfigurationAPI";

interface Option {
  areaName?: string;
  localeName?: string;
  physicalCity?: string;
  physicalZip?: string;
  physicalState?: string;
  districtName?: string;
  country?: string;
}

const AddStakeHolderContact: React.FC<any> = ({
  userData,
  action,
  stakeholderTypeId,
  StakeholderLabel,
  onCancel,
}) => {
  const userID = useSelector((state: RootState) => state.auth.userid);
  const [salutationOptions, setSalutationOptions] = useState<any[]>([]);
  const [stakeholderContactID, setStakeholderContactID] = useState<any>("");
  const [salutationTypeId, setSalutationTypeId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState<string[]>([]);
  const [phoneNumber, setPhoneNumber] = useState<string[]>([]);
  const [faxNumber, setFaxNumber] = useState<string[]>([]);
  const [contactUserId, setContactUserId] = useState("");
  const [comment, setComment] = useState("");
  const [isActive, setIsActive] = useState<boolean>(true);
  const [isAllowScheduling, setIsAllowScheduling] = useState<boolean>(false);
  const [isAllowMultipleAppointments, setIsAllowMultipleAppointments] =
    useState<boolean>(false);

  const [specalization, setSpecalization] = useState("");
  const [experience, setExperience] = useState("");

  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [contactData, setContactData] = useState<any[]>([]); // <-- Add state for contact data
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [selectedContact, setSelectedContact] = useState<any>(null);
  const [showPreviousContacts, setShowPreviousContacts] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [contactDetails, setContactDetails] = useState<any[]>([]);
  const [contactName, setContactName] = useState("");
  const [activeTab, setActiveTab] = useState("contact");
  const [newContactUserID, setNewContactUserID] = useState(null);
  const [isAlreadyUser, setIsAlreadyUser] = useState(true);
  const [userRoleOption, setUserRoleOption] = useState<any[]>([]);
  const [userRole, setUserRole] = useState<string | number | null>(null);
  const [isSaving, setIsSaving] = useState(false);

  const [stakeholderContactDetailKey, setstakeholderContactDetailKey] =
    useState<string | null>("0");

  const [stakeholderContactDetailFormKey, setstakeholderContactDetailFormKey] =
    useState<string | null>("0");

  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures,
  );

  const editContact = allowedFeatures.has(PARTIES_MASTER_ACTIONS.CONTACT_EDIT);
  const addNewUser = allowedFeatures.has(
    PARTIES_MASTER_ACTIONS.CONTACT_REGISTER_USER,
  );

  const params = {
    salutation: {
      groupName: PICKLIST_GROUP_NAME.Salutation_Type,
      triggerById: userID,
    },
    webRole: {
      groupName: PICKLIST_GROUP_NAME.Web_Application_Role,
      triggerById: userID,
    },
  };
  const [fullName, setFullName] = useState("");
  // Import moment

  const [showTooltip, setShowTooltip] = useState(false);

  const handlePDFClick = () => {
    if (selectedContact) {
      // Extract the four fields from the selectedContact

      setShowTooltip(false);

      const { createdbyname, createddate, modifiedbyname, modifieddate } =
        selectedContact;

      // Format the date using moment.js
      const formattedCreatedDate =
        moment(createddate).format("MM/DD/YYYY hh:mm A");
      const formattedModifiedDate =
        moment(modifieddate).format("MM/DD/YYYY hh:mm A");

      // Set the values in the state
      setContactDetails([
        {
          createdbyname,
          createddate: formattedCreatedDate, // Use formatted date
          modifiedbyname,
          modifieddate: formattedModifiedDate, // Use formatted date
        },
      ]);

      // Show the drawer
      setShowDrawer(true);
    }
  };
  const handleCloseDrawer = () => {
    setShowDrawer(false);
  };

  function formatUserName(name: string): string {
    return (
      name
        .replace(/\(U\)/g, "(") // Replace (U) with just (
        .replace(/\s*\(E\)\s*/g, "") // Remove (E)
        .replace(/;/g, "-") // Replace ; with -
        .trim() + " )"
    ); // Ensure proper closing bracket
  }

  const getUserRole = async () => {
    try {
      const userRoleData = await getUserRoleForPMC();

      // Define the structure for each role item
      type RoleItem = { value: number; label: string };

      const allRoles: RoleItem[] = userRoleData.map(
        (item: { webRoleId: number; webRoleName: string }): RoleItem => ({
          value: item.webRoleId,
          label: item.webRoleName,
        }),
      );

      const allowedRoles: string[] = [
        WEB_ROLE.Case_Manager,
        WEB_ROLE.QME_DoctorPMC,
        WEB_ROLE.Transcriber,
        WEB_ROLE.Historian,
        WEB_ROLE.Billing_Specialist,
        WEB_ROLE.Editor,
        WEB_ROLE.Scheduler,
        WEB_ROLE.Medical_Assistant,
        WEB_ROLE.IndependentQMEDoctor,
        WEB_ROLE.Record_Reviewer,
        WEB_ROLE.Claims_Administrator,
        WEB_ROLE.Supervisor,
        WEB_ROLE.Practice_Manager,
      ];

      const filteredRoles: RoleItem[] = allRoles.filter((role: RoleItem) =>
        allowedRoles.includes(role.label),
      );

      setUserRoleOption(filteredRoles);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getUserRole();
  }, [StakeholderLabel]);

  const fetchContactUserData = async (isFreshFetch = false) => {
    const userNameData = await getuserName(
      stakeholderTypeId,
      userRole ? userRole : null,
    );

    let transformedOptionsuser = userNameData.map(
      (item: { userid: number; userfullname: string }) => ({
        value: item.userid,
        label: formatUserName(item.userfullname),
      }),
    );

    // If it's a fresh fetch, do not include any previously edited names
    if (!isFreshFetch && selectedContact?.contactuserid) {
      const isUserAlreadyInList = transformedOptionsuser.some(
        (option: { value: number; label: string }) =>
          option.value === selectedContact.contactuserid,
      );

      if (!isUserAlreadyInList) {
        transformedOptionsuser.push({
          value: selectedContact.contactuserid,
          label: formatUserName(selectedContact.contactusernameEdit),
        });
      }
    }

    setUserOptions(transformedOptionsuser);
  };

  const selectedUserRoleLabel = userRoleOption.find(
    (role) => role.value === userRole,
  )?.label;

  const saluationLabel = salutationOptions.find(
    (role) => role.value === salutationTypeId,
  )?.label;

  const getUserDataFromCredential = async () => {
    try {
      const userCredentialData = await fetcheaderinfo(contactUserId);
      if (userCredentialData && contactUserId) {
        setSalutationTypeId(userCredentialData?.salutationtypeid);
        setFirstName(userCredentialData?.firstname);
        setMiddleName(userCredentialData?.middlename);
        setLastName(userCredentialData?.lastname);
        setEmailId(
          userCredentialData?.emailid
            ? userCredentialData?.emailid
                .split(",")
                .map((num: string) => num.trim())
            : [],
        );
        setPhoneNumber(
          userCredentialData?.phonenumber
            ? userCredentialData?.phonenumber
                .split(",")
                .map((num: string) => num.trim())
            : [],
        );
        setFaxNumber(
          userCredentialData?.faxnumber
            ? userCredentialData?.faxnumber
                .split(",")
                .map((num: string) => num.trim())
            : [],
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getUserDataFromCredential();
  }, [contactUserId]);

  const fetchData = async () => {
    try {
      const salutationData = await fetchPickListByGroupName(params.salutation);
      setSalutationOptions(salutationData || []);

      const data = await GetStakeholderContactInfo(userData);

      const formattedData = (data || []).map((item: any) => ({
        ...item,

        isAllowScheduling: item.isAllowScheduling == 1 ? "Yes" : "No",
      }));

      setContactData(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (userRole) {
      fetchContactUserData();
    }
  }, [userRole]);

  useEffect(() => {
    if (selectedContact) {
      fetchContactUserData();
    }
  }, [selectedContact]);

  const handleAddContact = () => {
    // Reset all states
    setUserRole("");
    setStakeholderContactID("");
    setContactName("");
    setSalutationTypeId("");
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setExperience("");
    setSpecalization("");
    setEmailId([]);
    setPhoneNumber([]);
    setFaxNumber([]);
    setContactUserId("");
    setComment("");
    setIsActive(true);
    setIsAllowScheduling(false);
    setIsAllowMultipleAppointments(false);
    setShowForm(true);
    setSelectedContact(null); // Reset selected contact when adding a new one

    // Clear user options and fetch fresh data
    setUserOptions([]);
    fetchData(); // Pass a flag to indicate it's a fresh fetch
    fetchContactUserData(true);
    setstakeholderContactDetailKey(null);
  };

  // Close the form without saving
  const handleCancel = () => {
    setShowModal(true); // Show confirmation modal
  };

  const closeForm = () => {
    onCancel();
  };

  const handleConfirmCancel = () => {
    setStakeholderContactID("");
    setContactName("");
    setSalutationTypeId("");
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setEmailId([]);
    setPhoneNumber([]);
    setFaxNumber([]);
    setContactUserId("");
    setComment("");
    setIsActive(true);
    setIsAllowScheduling(false);
    setIsAllowMultipleAppointments(false);
    setShowForm(false);
    setShowModal(false);
    setstakeholderContactDetailKey("0");
    setcommunicationDetailSubKey("0");
    setCredentialDetailSubKey("0");
    setSelectedContact(null);
    // Close modal after confirmation
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close modal without resetting form
  };

  const handleEdit = (contact: any) => {
    setFullName("");
    setstakeholderContactDetailKey(null);
    setSelectedContact(contact);
    setShowForm(true);

    // Update userOptions immediately
    setUserOptions((prevUserOptions) => {
      const isUserAlreadyInList = prevUserOptions.some(
        (option) => option.value === contact.contactuserid,
      );

      if (!isUserAlreadyInList) {
        return [
          ...prevUserOptions,
          { value: contact.contactuserid, label: contact.contactusernameEdit },
        ];
      }

      return prevUserOptions;
    });

    setStakeholderContactID(contact.stakeholdercontactid || "");

    setUserRole(contact.defaultWebRoleId ? contact.defaultWebRoleId : null);
    setContactName(contact.contactfullname || "");
    setSalutationTypeId(contact.salutationtypeid || "");
    setFirstName(contact.firstname || "");
    setMiddleName(contact.middlename || "");
    setLastName(contact.lastname || "");
    setSpecalization(contact.specialization || "");
    setExperience(contact.experienceinyears || "");
    setIsAllowScheduling(contact.isAllowScheduling === "Yes");
    setIsAllowMultipleAppointments(contact.isAllowsMultipleAppointment === 1);
    setEmailId(
      contact.emailaddress
        ? contact.emailaddress.split(",").map((num: string) => num.trim())
        : [],
    );
    setPhoneNumber(
      contact.phonenumber
        ? contact.phonenumber.split(",").map((num: string) => num.trim())
        : [],
    );
    setFaxNumber(
      contact.faxnumber
        ? contact.faxnumber.split(",").map((num: string) => num.trim())
        : [],
    );

    setContactUserId(contact.contactuserid || "");
    setComment(contact.comments || "");
    setIsActive(contact.isactive === 1);
  };

  const isSpecialStakeholder =
    StakeholderLabel === STAKEHOLDER_TYPE.QME_Doctor ||
    selectedUserRoleLabel === WEB_ROLE.QME_Doctor ||
    selectedUserRoleLabel === WEB_ROLE.IndependentQMEDoctor;
  // const isIndependentDoctor =
  //   selectedUserRoleLabel === WEB_ROLE.IndependentQMEDoctor;

  const validateContactForm = () => {
    // Prepare values to pass for validation
    const validationErrors = validateStakeholderContactInfo(
      userRole,
      salutationTypeId,
      firstName,
      emailId,
      phoneNumber,
      faxNumber,
      isSpecialStakeholder,

      specalization, // Pass specialization
      experience, // Pass experience
      StakeholderLabel,
      selectedUserRoleLabel,
    );

    // Call the validation function

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n")); // Show error messages directly
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleMapAction = async (row: any, action: string) => {
    const data = await GetDoctorDetails(row?.stakeholdercontactid);
    const rawLocationJson = data?.associatedLocations || [];
    const locationList: Location[] = rawLocationJson.map((loc: any) => ({
      fax: loc?.faxnumber || "NA",
      phone: loc?.phonenumber || "NA",
      email: loc?.emailaddress || "NA",
      locationname: loc?.locationname || "NA",
      locationaddress: loc?.locationaddress || "NA",
      latitude: loc?.latitude || null,
      longitude: loc?.longitude || null,
    }));

    if (locationList?.length > 0) {
      sessionStorage.removeItem("selectedMapData");
      sessionStorage.setItem(
        "selectedMapData",
        JSON.stringify({
          locations: locationList,
          tab: "QME Schedule",
        }),
      );
      window.open("/#/map/associated_locations", "_blank");
    } else {
      console.error("No associated locations found.");
    }
  };

  const handleMapActionForList = async () => {
    const data = await GetStakeholderLocationsList(userData);
    const rawLocationJson = data?.result || [];
    const locationList: Location[] = rawLocationJson.map((loc: any) => ({
      fax: loc?.faxNumber || "NA",
      phone: loc?.phoneNumber || "NA",
      email: loc?.emailAddress || "NA",
      locationname: loc?.locationName || "NA",
      locationaddress: loc?.locationAddress || "NA",
      latitude: loc?.latitude || null,
      longitude: loc?.longitude || null,
    }));

    if (locationList?.length > 0) {
      sessionStorage.removeItem("selectedMapData");
      sessionStorage.setItem(
        "selectedMapData",
        JSON.stringify({
          locations: locationList,
          tab: "QME Schedule",
        }),
      );
      window.open("/#/map/associated_locations", "_blank");
    } else {
      console.error("No associated locations found.");
    }
  };

  const handleSave = async () => {
    if (isSaving) return;
    if (validateContactForm()) {
      setIsSaving(true);
      try {
        const payloadAdd = {
          stakeholderId: userData,
          salutationTypeId: salutationTypeId,
          firstName: firstName.trim(),
          middleName: middleName.trim(),
          lastName: lastName.trim(),
          specialization: specalization ? specalization : "",
          // experienceinyears: experience ? experience : "",
          isAllowScheduling: isAllowScheduling ? 1 : 0,
          isAllowsMultipleAppointment: isAllowMultipleAppointments ? 1 : 0,
          emailAddress: emailId.length > 0 ? emailId.join(",") : "",
          phoneNumber: phoneNumber.length > 0 ? phoneNumber.join(",") : "",
          faxNumber: faxNumber.length > 0 ? faxNumber.join(",") : "",
          contactUserId: contactUserId ? contactUserId : null,
          defaultWebRoleId: userRole ? userRole : 0,
          comments: comment,
          Isactive: isActive ? 1 : 0,
          createdBy: userID,
        };

        const payloadUpdate = {
          stakeholderId: userData,
          stakeholderContactId: stakeholderContactID,
          salutationTypeId: salutationTypeId,
          firstName: firstName.trim(),
          middleName: middleName.trim(),
          lastName: lastName.trim(),
          specialization: specalization ? specalization : "",
          //  experienceinyears: experience ? experience : "",
          isAllowScheduling: isAllowScheduling ? 1 : 0,
          isAllowsMultipleAppointment: isAllowMultipleAppointments ? 1 : 0,
          emailAddress: emailId.length > 0 ? emailId.join(",") : "",
          phoneNumber: phoneNumber.length > 0 ? phoneNumber.join(",") : "",
          faxNumber: faxNumber.length > 0 ? faxNumber.join(",") : "",
          contactUserId: contactUserId ? contactUserId : null,
          defaultWebRoleId: userRole ? userRole : 0,
          comments: comment,
          Isactive: isActive ? 1 : 0,
          createdBy: userID,
        };

        const isUpdate =
          selectedContact?.stakeholdercontactid || stakeholderContactID
            ? true
            : false;
        const apiMethod = isUpdate
          ? updateStakeholderContact
          : addStakeholderContact;

        const response = await apiMethod(isUpdate ? payloadUpdate : payloadAdd);

        const successMessage = isUpdate
          ? "Contact updated successfully."
          : "Contact created successfully.";

        if (response.isSuccess) {
          const selectedSalutation = salutationOptions.find(
            (option) => option.value === salutationTypeId,
          );
          const salutationLabel = selectedSalutation
            ? selectedSalutation.label
            : "";

          // Construct full name
          const formattedFullName =
            `${salutationLabel} ${firstName.trim()} ${middleName.trim()} ${lastName.trim()}`.trim();

          // Update state
          setFullName(formattedFullName);

          setSnackbarMessage(successMessage);
          setError("success");
          setSnackbarOpen(true);
          setStakeholderContactID(response.result);
          fetchData();
          setShowForm(false);
          setstakeholderContactDetailKey("0");
          setcommunicationDetailSubKey("0");
          setCredentialDetailSubKey("0");
          if (isSpecialStakeholder) {
            setShowForm(true);
            fetchData();
            fetchContactUserData();
            if (!isUpdate && response.result) {
              const result = await addPartyNotificationConfiguration(
                response.result,
              );
            }
          }
          if (!isSpecialStakeholder) {
            setShowForm(false);
            fetchData();
            fetchContactUserData();
            setstakeholderContactDetailKey("0");
          }
        } else {
          setSnackbarMessage("Failed to add or update contact");
          setError("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        setSnackbarMessage(
          "An error occurred while saving contact details. Please try again.",
        );
        setError("error");
        setSnackbarOpen(true);
        console.error("Error during API call:", error);
      } finally {
        setIsSaving(false);
      }
    }
  };

  const stakeholderContactDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={stakeholderContactDetailKey}
      onSelect={(key) => setstakeholderContactDetailKey(key as string)}
    />
  );

  const stakeholderContactDetailFormAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={stakeholderContactDetailFormKey}
      onSelect={(key) => setstakeholderContactDetailFormKey(key as string)}
    />
  );

  const [contactDetailSubKey, setContactDetailSubKey] = useState<string | null>(
    "0",
  );

  const contactDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={contactDetailSubKey}
      onSelect={(key) => setContactDetailSubKey(key as string)}
    />
  );
  const [communicationDetailSubKey, setcommunicationDetailSubKey] = useState<
    string | null
  >("0");

  const communicationDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={communicationDetailSubKey}
      onSelect={(key) => setcommunicationDetailSubKey(key as string)}
    />
  );
  const [credentialDetailSubKey, setCredentialDetailSubKey] = useState<
    string | null
  >("0");

  const credentialnDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={credentialDetailSubKey}
      onSelect={(key) => setCredentialDetailSubKey(key as string)}
    />
  );

  const [showUserDrawer, setShowUserDrawer] = useState(false);

  const openDrawerWithType = () => {
    setShowUserDrawer(true);
    fetchContactUserData();
    setNewContactUserID(null);
  };

  const updateCredentialDropdown = async (id: any) => {
    if (!newContactUserID) return;

    const userNameData = await getuserName(
      stakeholderTypeId,
      userRole ? userRole : null,
    );

    const isValidUser = userNameData?.some(
      (item: any) => Number(item.userid) === Number(id),
    );

    if (!isValidUser) return;

    setContactUserId(id);
    setIsAlreadyUser(true);
  };

  const handlePartyDrawerClose = async () => {
    setShowUserDrawer(false);
    await fetchContactUserData(); // optional, or you can also move this into useEffect
  };

  useEffect(() => {
    if (newContactUserID) {
      updateCredentialDropdown(newContactUserID);
    }
  }, [newContactUserID]);

  const handleToggleSort = () => {
    setIsAlreadyUser((prev) => !prev);
    setContactUserId("");
    // Clear the fields populated from fetched user data
    if (!isSpecialStakeholder) {
      setSalutationTypeId("");
    }
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setEmailId([]);
    setPhoneNumber([]);
    setFaxNumber([]);
  };

  const clearUserFields = () => {
    if (!isSpecialStakeholder) {
      setSalutationTypeId("");
    }
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setEmailId([]);
    setPhoneNumber([]);
    setFaxNumber([]);
    setContactUserId(""); // Also reset contact user if needed
  };

  useEffect(() => {
    if (isSpecialStakeholder && salutationOptions.length > 0) {
      const drOption = salutationOptions.find(
        (option) => option.label === "Dr.",
      );
      if (drOption) {
        setSalutationTypeId(drOption.value);
      }
    }
  }, [isSpecialStakeholder, salutationOptions]);

  return (
    <>
      {" "}
      {(activeTab === "contact" || !isSpecialStakeholder) && showForm && (
        <>
          {stakeholderContactDetailFormAccordion([
            {
              title: "Contact Details",
              content: (
                <>
                  <Row className="align-items-center mb-3">
                    {StakeholderLabel === STAKEHOLDER_TYPE.PMC && (
                      <Col sm={3} className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="User Role"
                          value={userRole}
                          options={userRoleOption}
                          onChange={(e) => {
                            setUserRole(e.target.value);
                            clearUserFields(); // Reset all fields
                          }}
                          name="userRole"
                          required={true}
                          disabled={!editContact}
                        />
                      </Col>
                    )}

                    <Col sm={6} md={4}>
                      <div className="d-flex align-items-center toggle-btn">
                        <span className="me-3 fw-semibold">
                          Is User Already Created
                        </span>
                        <span className="me-2">No</span>
                        <Form.Check
                          type="switch"
                          id="sort-switch"
                          checked={isAlreadyUser}
                          onChange={handleToggleSort}
                          disabled={!editContact}
                        />
                        <span className="ms-2">Yes</span>
                      </div>
                    </Col>
                  </Row>

                  {credentialnDetailSubAccordion([
                    {
                      title: "Credential Details",
                      content: (
                        <>
                          <Row>
                            <Col sm={3} className="selection_dropdown">
                              <SearchableSingleSelectDropdown
                                label="Contact User"
                                value={contactUserId}
                                options={userOptions}
                                onChange={(e) =>
                                  setContactUserId(e.target.value)
                                }
                                name="ContactUserId"
                                disabled={
                                  !editContact ||
                                  !isAlreadyUser ||
                                  (StakeholderLabel === STAKEHOLDER_TYPE.PMC &&
                                    !userRole)
                                }
                              />
                            </Col>
                            {!isAlreadyUser && addNewUser && (
                              <Col sm={3} className="d-flex align-items-center">
                                <Button
                                  className="btn btn-primary d-flex align-items-center float-end"
                                  onClick={() => openDrawerWithType()}
                                  disabled={
                                    StakeholderLabel === STAKEHOLDER_TYPE.PMC &&
                                    !userRole
                                  }
                                >
                                  <span className="material-icons mx-1">
                                    add
                                  </span>
                                  Register New User
                                </Button>
                              </Col>
                            )}

                            <Col sm={12} className="mt-3">
                              <MultilineTextBox
                                label="Comment"
                                name="comments"
                                value={comment}
                                onChange={(e) => {
                                  const trimmedValue =
                                    e.target.value.trimStart();
                                  setComment(trimmedValue || "");
                                }}
                                maxLength={1000}
                                disabled={!editContact}
                              />
                            </Col>
                          </Row>
                          <Row className="mt-2">
                            <div className="col-md-3">
                              <div className="form-check p-2 py-2">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="Isactive"
                                  name="Isactive"
                                  checked={isActive}
                                  onChange={(e) =>
                                    setIsActive(e.target.checked)
                                  }
                                  style={{ cursor: "pointer" }}
                                  disabled={
                                    !selectedContact?.stakeholdercontactid ||
                                    !editContact
                                  }
                                />
                                <label className="form-check-label">
                                  Is Active?{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                              </div>
                            </div>
                          </Row>
                        </>
                      ),
                    },
                  ])}

                  {contactDetailSubAccordion([
                    {
                      title: "Details",
                      content: (
                        <>
                          <Row className="mt-1">
                            <Col sm={3} className="selection_dropdown">
                              <SearchableSingleSelectDropdown
                                label="Salutation"
                                value={salutationTypeId}
                                options={salutationOptions}
                                onChange={(e) =>
                                  setSalutationTypeId(e.target.value)
                                }
                                name="Salutationtypeid"
                                required={true}
                                disabled={
                                  !!contactUserId ||
                                  isSpecialStakeholder ||
                                  !editContact
                                }
                              />
                            </Col>
                            <Col sm={3}>
                              <TextInput
                                label="First Name"
                                name="Firstname"
                                value={firstName}
                                onChange={(e) => {
                                  const onlyText = e.target.value.replace(
                                    /[^a-zA-Z]/g,
                                    "",
                                  );
                                  setFirstName(onlyText);
                                }}
                                spacesTrim={true}
                                required={true}
                                maxLength={30}
                                disabled={!!contactUserId || !editContact}
                              />
                            </Col>
                            <Col sm={3}>
                              <TextInput
                                label="Middle Name"
                                name="Middlename"
                                value={middleName}
                                onChange={(e) => {
                                  const onlyText = e.target.value.replace(
                                    /[^a-zA-Z]/g,
                                    "",
                                  );
                                  setMiddleName(onlyText);
                                }}
                                spacesTrim={true}
                                maxLength={20}
                                disabled={!!contactUserId || !editContact}
                              />
                            </Col>
                            <Col sm={3}>
                              <TextInput
                                label="Last Name"
                                name="Lastname"
                                value={lastName}
                                onChange={(e) => {
                                  const onlyText = e.target.value.replace(
                                    /[^a-zA-Z]/g,
                                    "",
                                  );
                                  setLastName(onlyText);
                                }}
                                spacesTrim={true}
                                maxLength={30}
                                disabled={!!contactUserId || !editContact}
                              />
                            </Col>
                          </Row>
                          {(isSpecialStakeholder ||
                            saluationLabel == "Dr.") && (
                            <Row className="mt-3 align-items-end d-flex align-items-center">
                              <Col sm={6}>
                                <TextInput
                                  label="Specialization"
                                  name="specialization"
                                  value={specalization}
                                  onChange={(e) =>
                                    setSpecalization(e.target.value)
                                  }
                                  maxLength={200}
                                  required={true}
                                  disabled={!editContact}
                                />
                              </Col>

                              <Col sm={3}>
                                <div className="form-check ps-2 d-flex align-items-center">
                                  <label
                                    className="form-check-label mb-0 me-3"
                                    htmlFor="Isactive"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Allow Scheduling ?
                                  </label>
                                  <input
                                    type="checkbox"
                                    className="form-check-input "
                                    id="Isactive"
                                    name="Isactive"
                                    checked={isAllowScheduling}
                                    disabled={!editContact}
                                    onChange={(e) =>
                                      setIsAllowScheduling(e.target.checked)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "6px",
                                    }}
                                  />
                                  <span style={{ minWidth: "30px" }}>
                                    {isAllowScheduling ? "Yes" : "No"}
                                  </span>
                                </div>
                              </Col>
                              <Col sm={3}>
                                <div className="form-check ps-2 d-flex align-items-center">
                                  <label
                                    className="form-check-label mb-0 me-3"
                                    htmlFor="Isactive"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Allow Multiple Appointments ?
                                  </label>
                                  <input
                                    type="checkbox"
                                    className="form-check-input "
                                    id="Isactive"
                                    name="Isactive"
                                    checked={isAllowMultipleAppointments}
                                    disabled={!editContact}
                                    onChange={(e) =>
                                      setIsAllowMultipleAppointments(
                                        e.target.checked,
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "6px",
                                    }}
                                  />
                                  <span style={{ minWidth: "30px" }}>
                                    {isAllowMultipleAppointments ? "Yes" : "No"}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          )}
                        </>
                      ),
                    },
                  ])}

                  {communicationDetailSubAccordion([
                    {
                      title: "Communication Details",
                      content: (
                        <>
                          <Row>
                            <Col sm={4}>
                              <TagComponent
                                label="Email Addressp"
                                value={emailId}
                                onChange={setEmailId}
                                  onClick={() => {
    if (emailId.length > 0) {
      window.location.href = `mailto:${emailId[0]}`;
    }
  }}
                                required={true}
                                disabled={!editContact}
                              />
                            </Col>
                            <Col sm={4}>
                              <TagComponent
                                label="Phone Number"
                                value={phoneNumber}
                                onChange={(newValues) =>
                                  setPhoneNumber(newValues.map(String))
                                }
                                isPhoneOrFax={true}
                                disabled={!editContact}
                              />
                            </Col>
                            <Col sm={4}>
                              <TagComponent
                                label="Fax No"
                                value={faxNumber}
                                onChange={(newValues) =>
                                  setFaxNumber(newValues.map(String))
                                }
                                isPhoneOrFax={true}
                                disabled={!editContact}
                              />
                            </Col>
                          </Row>
                        </>
                      ),
                    },
                  ])}

                  <Row className="mt-3 mb-3">
                    <Col sm={12} className="d-flex justify-content-end">
                      {editContact && (
                        <Button
                          variant="outline-info"
                          className="d-flex align-items-center"
                          onClick={handleCancel}
                        >
                          <span className="material-icons mr-2">close</span>
                          Cancel
                        </Button>
                      )}
                      {editContact && (
                        <Button
                          type="submit"
                          variant="primary"
                          className="ms-3 d-flex align-items-center"
                          onClick={handleSave}
                          disabled={isSaving}
                        >
                          <span className="material-icons mx-1">save</span>Save
                        </Button>
                      )}
                    </Col>
                  </Row>

                  {/* {stakeholderContactID &&
                    (StakeholderLabel === STAKEHOLDER_TYPE.QME_Doctor ||
                      selectedUserRoleLabel === WEB_ROLE.QME_Doctor) && ( */}
                  {isSpecialStakeholder && stakeholderContactID && (
                    <AssociatedClinicForm
                      stakeholdercontactid={stakeholderContactID}
                      contactName={fullName || contactName}
                      activeTab={activeTab}
                      closeForm={closeForm}
                    />
                  )}
                  {isSpecialStakeholder && stakeholderContactID && (
                    <PartyNotificationPreference
                      stakeholdercontactid={stakeholderContactID}
                    />
                  )}

                  {/* )} */}

                  <OverlayDrawer
                    title={"Logs"}
                    open={showDrawer}
                    onClose={handleCloseDrawer}
                    placement="bottom"
                  >
                    <DataTable
                      headers={CONTACT_LOG_HEADERS}
                      rows={contactDetails}
                      isLogTable={true}
                    />
                  </OverlayDrawer>
                </>
              ),
            },
          ])}
        </>
      )}
      <Modal show={showModal} onHide={handleCloseModal}>
        {/* <Modal.Header closeButton>
            <Modal.Title>Confirm Cancellation</Modal.Title>
          </Modal.Header> */}
        <Modal.Body className="fw-bold text-left modelheading">
          <div>Are you sure you want to cancel the form?</div>
          <div style={{ fontWeight: "300" }}>
            {" "}
            Any unsaved data will be lost.
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end bg-light ">
          <Button
            variant="outline-info"
            className="d-flex align-items-center"
            onClick={handleCloseModal}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={handleConfirmCancel}
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <>
        {/* Condition 1: For non-special stakeholders, only if form is not visible */}
        {!isSpecialStakeholder &&
          StakeholderLabel != STAKEHOLDER_TYPE.PMC &&
          !showForm &&
          stakeholderContactDetailAccordion([
            {
              title: "Contact List",
              content: (
                <>
                  <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 cancelappointment col mb-3">
                    <h3 className="mr-2 me-auto">List</h3>
                    <div className="address_cta_pos_relative mt-1">
                      <div className="container-fluid">
                        {editContact && (
                          <div className="hstack gap-2">
                            <Button
                              className="btn btn-primary d-flex align-items-center"
                              onClick={handleAddContact}
                              style={{ float: "right" }}
                            >
                              <span className="material-icons me-2">add</span>
                              Add
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {showPreviousContacts && (
                    <DataTable
                      headers={STAKEHOLDERS_CONTACT}
                      rows={contactData}
                      onAction={(contact) => handleEdit(contact)}
                    />
                  )}
                </>
              ),
            },
          ])}

        {/* Condition 2: For special stakeholders, regardless of showForm */}
        {(isSpecialStakeholder || StakeholderLabel == STAKEHOLDER_TYPE.PMC) &&
          activeTab === "contact" &&
          !showForm &&
          stakeholderContactDetailAccordion([
            {
              title: "Contact List",
              content: (
                <>
                  <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 cancelappointment col mb-3">
                    <h3 className="mr-2 me-auto">List</h3>
                    <div className="address_cta_pos_relative mt-1">
                      <div className="container-fluid">
                        <div className="hstack gap-2">
                          {!showForm && editContact && (
                            <div className="d-flex align-items-center">
                              {contactData?.length > 0 && (
                                <Button
                                  variant="outline"
                                  className="d-flex align-items-center btn-text-border p-1 me-2"
                                  onClick={handleMapActionForList}
                                >
                                  <img
                                    src="/map.png"
                                    alt="map"
                                    style={{ width: "30px", height: "23px" }}
                                  />
                                </Button>
                              )}
                              <Button
                                className="btn btn-primary d-flex align-items-center float-end"
                                onClick={handleAddContact}
                              >
                                <span className="material-icons mx-1">add</span>
                                Add
                              </Button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {(isSpecialStakeholder ||
                    StakeholderLabel == STAKEHOLDER_TYPE.PMC) &&
                    showPreviousContacts && (
                      <DataTable
                        headers={STAKEHOLDERS_QME_CONTACT}
                        rows={contactData}
                        onAction={(contact) => handleEdit(contact)}
                        onDownloadAction={handleMapAction}
                      />
                    )}
                </>
              ),
            },
          ])}
      </>
      <Col sm={6} className="d-flex justify-content-start mb-4">
        {selectedContact?.stakeholdercontactid ? (
          <OverlayTrigger
            show={showTooltip}
            placement="auto"
            trigger={["hover", "focus"]} // Important to prevent sticky tooltip
            delay={{ show: 200, hide: 100 }}
            overlay={
              <Tooltip style={{ backgroundColor: "#b3e0ff" }}>Logs</Tooltip>
            }
          >
            <div className="d-flex">
              <Button
                type="button"
                className="btn btn-primary d-flex align-items-center mx-2"
                onClick={handlePDFClick}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <span className="material-icons">description</span>
              </Button>
            </div>
          </OverlayTrigger>
        ) : null}

        {showForm ? (
          <button
            className="btn d-flex align-items-center btn-text-border me-2"
            onClick={handleConfirmCancel}
          >
            <span className="material-icons">arrow_back</span>Back
          </button>
        ) : (
          <button
            className="btn d-flex align-items-center btn-text-border me-2"
            onClick={closeForm}
          >
            <span className="material-icons">arrow_back</span>Back
          </button>
        )}
      </Col>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
      <AddNewUserDrawer
        title={"Add User"}
        open={showUserDrawer}
        onClose={handlePartyDrawerClose}
        placement="end"
      >
        <AddNewContactUser
          StakeholderLabel={StakeholderLabel}
          selectedUserRoleLabel={selectedUserRoleLabel}
          setNewContactID={setNewContactUserID}
          onBack={handlePartyDrawerClose}
        />
      </AddNewUserDrawer>
    </>
  );
};

export default AddStakeHolderContact;
